export default "query subscriberKeyByEsmoId ($esmoId:String!){\n    subscriberKeyByEsmoId(esmoId: $esmoId)\n}";